// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2WNkJ","header":"Messages_header__2ZPzk"};